/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StringResources from './nls/StringResources';
import { Flyout } from 'ca-ui-toolkit';

/**
 * The SlotEditorItemFlyout component is responsible for the User Interface for a flyout of a single slot data item
 */
class SlotEditorItemFlyout extends Component {

	_onCloseFlyout = () => {
		if(this.props.onClose) {
			this.props.onClose();
		}
	}
	render() {
		const tooltipLabel = StringResources.get('slotEditor_slotItem_tooltip');
		const querySubjectItem = this._renderQuerySubjectItem();
		if (querySubjectItem) {
			return (
				<Flyout
					domNodeToAttachTo={document.body}
					triggerNode={this.props.domNode}
					offset={10}
					placement={'topCentred'}
					candidatePlacement={['topCentred']}
					onClose={this._onCloseFlyout}
				>
					<div className="slotEditorItem__disambiguatingTooltipTitle">{tooltipLabel}</div>
					<div className="slotEditorItem__disambiguatingTooltip">{querySubjectItem}</div>
				</Flyout>
			);
		}
		return null;
	}

	_renderQuerySubjectItem() {
		return this.props.dashboardApi.getFeature('DataSources.UI').getColumnSourceTree(this.props.sourceId, this.props.columnId);
	}
}

SlotEditorItemFlyout.propTypes = {
	domNode: PropTypes.object.isRequired,
	dashboardApi: PropTypes.object.isRequired,
	columnId: PropTypes.string,
	sourceId: PropTypes.string,
	onClose: PropTypes.func
};

export default SlotEditorItemFlyout;



// WEBPACK FOOTER //
// ./src/js/SlotEditorItemFlyout.js